import { render, staticRenderFns } from "./BaseScrollButton.vue?vue&type=template&id=565e21cc&scoped=true&"
import script from "./BaseScrollButton.vue?vue&type=script&lang=js&"
export * from "./BaseScrollButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseScrollButton.vue?vue&type=style&index=0&id=565e21cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e21cc",
  null
  
)

export default component.exports